// removed by extract-text-webpack-plugin
module.exports = {"unstyledList":"aw_ax","inlineList":"aw_ay aw_ax","srOnly":"aw_az","hideBelowMD":"aw_a0","hideBelowLG":"aw_a1","hideAboveSM":"aw_a2","hideAboveMD":"aw_a3","showMD":"aw_a4","heroGradient":"aw_a5","tintGradient":"aw_a6"};


//////////////////
// WEBPACK FOOTER
// ./app/src/base-styles/mixins.module.css
// module id = 29
// module chunks = 27